/*
 * Swachhata Hi Seva 2026 — the school SWM report (DoSEL "Draft_Portal format_
 * Swachhata Hi Seva..Solid Waste Mgmt."). Question wording follows the draft.
 *
 * Option keys MUST match SURVEY_OPTIONS in Backend2/Controllers/
 * SwachhataHiSevaController.js — the server rejects anything else.
 */

export const SURVEY_TITLE = "Swachhata Hi Seva 2026";
export const SURVEY_TAGLINE = "“Swachhata Mein Sahbhag, Swachh Bharat, Viksit Bharat”";

export const PHOTOS_MIN = 2;
export const PHOTOS_MAX = 3;
export const PHOTO_MAX_MB = 5;

// Q11 exposure-visit photos: geo-tagged (the photo's GPS, or the device's
// location stamped in when it has none). Must match VISIT_PHOTOS_* on the server.
export const VISIT_PHOTOS_MIN = 1;
export const VISIT_PHOTOS_MAX = 3;
export const VISIT_DESCRIPTION_MAX = 1000;

export const BINS_OPTIONS = [
  { key: "all_four", label: "Yes, all four installed" },
  { key: "not_installed", label: "Not installed" },
];

export const YES_NO = [
  { key: "yes", label: "Yes" },
  { key: "no", label: "No" },
];

export const COMPOST_OPTIONS = [...YES_NO, { key: "na", label: "Not applicable" }];

export const AWARENESS_TYPES = [
  { key: "gyan_yatra", label: "Swachhata Gyan Yatra / Awareness rally" },
  { key: "assembly", label: "School Assembly" },
  { key: "talk", label: "Awareness Talk / Lecture" },
  { key: "nukkad_natak", label: "Street Play / Nukkad Natak" },
  { key: "other", label: "Other" },
];

export const COMPETITIONS = [
  { key: "poster", label: "Poster Making" },
  { key: "rangoli", label: "Rangoli" },
  { key: "debate", label: "Debate" },
  { key: "poem", label: "Poem Recitation" },
  { key: "slogan", label: "Slogan Writing" },
  { key: "kabaad_se_jugaad", label: "Kabaad se Jugaad / Waste to Wealth" },
  { key: "other", label: "Other" },
];

export const REDUCTION_ACTIVITIES = [
  { key: "paper_reduction", label: "Paper reduction" },
  { key: "reuse", label: "Reuse of materials" },
  { key: "single_use_avoidance", label: "Avoidance of single-use items" },
  { key: "composting", label: "Composting / wet waste / garden waste" },
  { key: "dry_waste_recycling", label: "Dry-waste recycling" },
  { key: "other", label: "Other" },
];

export const QUESTIONS = {
  q1: "Whether 4 bins (Wet, Dry, Sanitary, Special Waste) are installed in the school?",
  q2: "Did the school conduct an awareness rally or other Solid Waste Management awareness activity?",
  q2a: "Type of awareness activity conducted",
  q3: "Which Solid Waste Management competitions / activities were organised by the school on the theme “Swachhata Evam Jal Sanchay Samvad / Dialogue on Cleanliness & Water Conservation”?",
  q4: "Number of students who participated in different activities / competitions",
  q5: "Number of teachers who participated in different activities / competitions",
  q6: "Number of community members who participated",
  q7: "Did the school conduct a Solid Waste Audit?",
  q8: "Did the school undertake any waste reduction, reuse, recycling or processing activity?",
  q8a: "Select activities",
  q9: "Is wet waste (leaves, leftover food etc.) composted within the school premises?",
  q10: "Upload photographs of campaign activities (2–3 photos)",
  // Q11 — added at the States' request (2026-09-21)
  q11: "Exposure visit conducted for students to Solid & Liquid Waste Management sites",
  q11Place: "Place of visit",
  q11Description: "Description",
  q11Students: "No. of students participated",
  q11Teachers: "No. of teachers participated",
  q11Photos: "Geo-tagged photos of the visit",
};

const labelOf = (list) => (key) => list.find((o) => o.key === key)?.label || key;
export const awarenessLabel = labelOf(AWARENESS_TYPES);
export const competitionLabel = labelOf(COMPETITIONS);
export const reductionLabel = labelOf(REDUCTION_ACTIVITIES);
export const binsLabel = labelOf(BINS_OPTIONS);
export const compostLabel = labelOf(COMPOST_OPTIONS);
